import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { ChronologyService } from '@services/chronology.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { AddService } from '@services/add.service';
import { ViewService } from '@services/view.service';
import * as _ from 'lodash';
import { rotateInDownLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-msports',
  templateUrl: './msports.component.html',
  styleUrls: ['./msports.component.sass'],
  animations: [
    rotateInDownLeftOnEnterAnimation({ anchor: 'searchPage' })
  ]
})
export class MsportsComponent implements OnInit {
  response: any = [];
  pageCounter = 1;
  btn_process=false;
  totalRecord = 0;
  application = "chronology";
  component = 'm';
  rows = 1;
  searchtxt = "";
  params: any = [];
  total_record = 0;
  pageno = 1;
  dataLoding = true;
  playLists: any = [];
  meta = "sports";
  router_param: any = [];
  constructor(private _addService: AddService, private _viewService: ViewService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private _chronologyService: ChronologyService, private _global: GlobalService) {
    this.rows = this._global.ROWS;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy: this._global.getSessionVal('id'),
      status:'active',
      ignoreComponents: true,
      meta: this.meta,
      rows: this.rows
    };


    this.loadAppData(p);

  }

  ngOnInit() {
  }
  remove(res){
    this.btn_process=true;
    let p={
      "component": this.component,
			"application": this.application,
      "id":res['id'],
      "meta":this.meta,
			"mediaType": "member",
			"mediaId": res['mediaId']
    };
    this._chronologyService.remove(p).subscribe(
      data => {
        this.btn_process = false;
        if (data["status"] == "1") {
          this._global.showMessage({ "type": 'success', "message": this._global.getVal(data,'message.info','') });
          let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
          this.loadAppData(p);
        }else{
          this._global.showMessage({ "type": 'warning', "message":this._global.getVal(data,'message.error','')  });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  isOwner(res) {
    return this._global.isOwner(this._global.getVal(res, 'createdBy', ''));
  }
    loadAppData(p) {
      this.dataLoding = true;
      this._chronologyService.search(p).subscribe(
        data => {
          this.dataLoding = false;
          this.params = this._global.getVal(data, 'request', '');
          this.response = data["response"]["docs"];
          this.total_record = this._global.getVal(data, 'response.numFound', '0');
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }

  showMember(obj){
    this.router.navigate(['/chronology/member'], { queryParams: { 'meta' : obj['meta'],'name':obj['name'] } });
  }
    onScrollDown() {
      if (!this.dataLoding) {
        this.dataLoding = true;
        if (this.total_record <= this.pageCounter * this.rows) {
          this.dataLoding = false;
        } else {
          let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
          p['start'] = this.pageCounter * this.rows;
          p['component'] = this.component;
          this._chronologyService.search(p).subscribe(
            data => {
              if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
                this.response = this.response.concat(data["response"]["docs"]);

                this.dataLoding = false;
                this.pageCounter += 1;
                this.params = this._global.getVal(data, 'request', '');
              } else {
                this.dataLoding = false;
              }
            },
            error => {
              console.log("error", JSON.stringify(error));
            });
          //  console.log('scrolled down!!', ev);

        }
      }
    }
    searchMedia(event: any) {
      this.dataLoding = true;
      this.response = [];
      let p = {
        component: this.component,
        application: this.application,
        start: 0,
        name: this.searchtxt,
        sortOrder: 'desc',
        meta: this.meta,
        sortString: 'createdTime',
        createdBy: this._global.getSessionVal('id'),
        ignoreComponents: true,
        rows: this.rows
      };
      this.loadAppData(p);
    }


  }

